var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Mutations, Actions } from '@/store/enums/PbiEmbeddedEnums';
import Pbi from '@/core/classes/Pbi';
import ApiService from '@/core/services/ApiService';
let PbiEmbeddedModule = class PbiEmbeddedModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.pbiConfig = {
            type: '',
            embedReport: [
                {
                    reportId: '',
                    reportName: '',
                    embedUrl: ''
                }
            ],
            embedToken: {
                token: '',
                tokenId: '',
                expiration: ''
            }
        };
        this.miningRole = {
            read: 0,
            export: 0,
            upload: 0,
            rls: 0
        };
        this.pbi = new Pbi(this.pbiConfig);
        this.loading = false;
        this.firstInit = true;
        this.date = null;
        // end: ACTION ======================================================================
    }
    // GETTER
    get getPbiReportComponent() {
        return this.firstInit;
    }
    get getDashboardConfigPbi() {
        return this.pbi.getPbiConfig();
    }
    get getIsDashboardConfigLoading() {
        return this.loading;
    }
    get getPbiMiningRole() {
        return this.miningRole;
    }
    get getPbiSelectedDate() {
        return this.date;
    }
    // MUTATION
    [_a = Mutations.SET_FIRST_INIT](data) {
        this.firstInit = data;
    }
    [_b = Mutations.SET_PBI_CONFIG](data) {
        this.pbi.setPbiConfig(data);
    }
    [_c = Mutations.SET_LOADING](state) {
        this.loading = state;
    }
    [_d = Mutations.SET_PBI_URL](url) {
        this.pbi.setPbiUrl(url);
    }
    [_e = Mutations.SET_IS_PBI_URL_COMPLETE_URL]() {
        this.pbi.setPbiIsCompleteUrl(true);
    }
    [_f = Mutations.SET_PBI_MINING_ROLE](payload) {
        this.miningRole = payload;
    }
    [_g = Mutations.SET_DATE_FILTER](payload) {
        this.date = payload;
    }
    // start: ACTION ======================================================================
    [_h = Actions.GET_PBI_CONFIG](payload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.pbi.getApiPbiConfig(payload);
            this.context.commit(Mutations.SET_LOADING, false);
        });
    }
    [_j = Actions.POST_PBI_CONFIG](payload) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.pbi.postApiPbiConfig(payload);
            this.context.commit(Mutations.SET_LOADING, false);
        });
    }
    // MINING ROLE
    [_k = Actions.GET_MINING_PBI_ROLE](payload) {
        return __awaiter(this, void 0, void 0, function* () {
            if (payload.groupId) {
                ApiService.post(`${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_OPEX_WEBAPI}/api/checkrole/?ver=v1`, {
                    groupId: payload.groupId,
                    menu: payload.menu
                }).then((res) => {
                    this.context.commit(Mutations.SET_PBI_MINING_ROLE, res.data.result.content);
                });
            }
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PbiEmbeddedModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PbiEmbeddedModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PbiEmbeddedModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PbiEmbeddedModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PbiEmbeddedModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PbiEmbeddedModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PbiEmbeddedModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], PbiEmbeddedModule.prototype, _h, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], PbiEmbeddedModule.prototype, _j, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], PbiEmbeddedModule.prototype, _k, null);
PbiEmbeddedModule = __decorate([
    Module
], PbiEmbeddedModule);
export default PbiEmbeddedModule;
